<template>
  <main class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>Danh sách bệnh nhân</h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item">
          <router-link to="/contact">{{ $t('contacts') }}</router-link>
        </li>
        <li class="breadcrumb-item active">Danh sách bệnh nhân</li>
      </ul>
    </div>
    <div class="tile">
      <div class="c-action">
        <div class="row">
          <div class="col-lg-12 c-action__right">
            <b-tabs class="c-tabs-button" small pills v-model="filterFormModel.type" @input="search">
              <b-tab title="Bệnh nhân của tôi"></b-tab>
              <b-tab title="Chưa phân tầng NC"></b-tab>
              <b-tab title="Cần gọi ngay"></b-tab>
              <b-tab title="Cần duyệt"></b-tab>
              <b-tab title="Ngừng theo dõi"></b-tab>
              <b-tab title="Có lỗi"></b-tab>
              <b-tab v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                     title="Chưa phân công"></b-tab>
              <b-tab v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                     title="Chờ cấp cứu"></b-tab>
              <b-tab v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                     title="Đang cấp cứu"></b-tab>
              <b-tab v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                     title="Chờ chuyển về cộng đồng"></b-tab>
              <b-tab v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                     title="Đang chăm sóc ở cộng đồng"></b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 c-action__right">
            <div class="c-search-all">
              <div class="c-search-all__inner cstooltip">
                <span class="cstooltiptext">
                  Hướng dẫn tìm kiếm:<br/><br/>
- Hỗ trợ tìm kiếm không phân biệt in hoa/in thường, không phân biệt có dấu hay không dấu (ngoại trừ chữ <b>Đ</b>)<br/>
- Hệ thống sẽ tìm kiếm theo các từ có trong cụm từ, để tìm kiếm chính xác theo đúng cụm từ thì đặt trong hai dấu ngoặc kép VD: <b>"Nguyễn Văn A"</b><br/>
- Tìm kiếm theo <b>Mã xét nghiệm</b> sẽ có kết quả chính xác bệnh nhân tương ứng
- Khi tìm kiếm bệnh nhân theo <b>Họ Tên</b>, để tăng độ chính xác thì có thể thêm thông tin <b>Năm sinh</b> vào nội dung tìm kiếm và kết hợp lọc theo <b>Bác sỹ/TNV</b><br/>
                </span>
                <i class="c-search-all__icon icon16-search-gadient"></i>
                <b-form-input
                    class="form-control form-control-sm is-border-1"
                    v-model="filterFormModel.keyword"
                    :placeholder="$t('keyword')"
                    @keyup="search"
                ></b-form-input>
              </div>
            </div>
            <div class="c-search-all" v-if="$store.state.user.permissions.includes('benhNhanListAll')">
              <div class="c-search-all__inner">
                <i class="c-search-all__icon icon16-search-gadient"></i>
                <b-form-input
                    class="form-control form-control-sm is-border-1"
                    v-model="filterFormModel.phone"
                    placeholder="SĐT"
                    @keyup="search"
                ></b-form-input>
              </div>
            </div>
            <user-group-select
                :model="filterFormModel"
                attribute="group"
                is-filter
                @change="load"
                v-if="$store.state.user.permissions.includes('benhNhanListAll')"
                place-holder="Chọn nhóm"
            ></user-group-select>
            <user-select
                :model="filterFormModel"
                attribute="doctorUser"
                :group-filter="filterFormModel.group" :roles-filter="['bac-sy-pho-nhom', 'bac-sy', 'bac-sy-truong-nhom', 'cap-cuu']"
                v-if="$store.state.user.permissions.find(p => ['benhNhanListAll', 'benhNhanListGroup'].includes(p))"
                @change="search"
                :isFilter="true"
                place-holder="Chọn bác sỹ"
            ></user-select>
            <user-select
                :model="filterFormModel"
                attribute="followUser"
                :group-filter="filterFormModel.group"
                role-filter="nvyt"
                v-if="$store.state.user.role !== 'nvyt'"
                :doctor-group-filter="filterFormModel.doctorUser || null"
                @change="search"
                :isFilter="true"
                place-holder="Chọn TNV"
            ></user-select>
            <dropdown
                :model="filterFormModel"
                attribute="nc"
                label="Lọc theo NC"
                :right-menu="true"
                type="bordered"
                icon="icon12-sort-descending-primary"
                :options="[
                {value: null, text: 'Tất cả'},
                {value: 'ncx', text: 'Chưa phân tầng'},
                {value: 'nc0', text: 'NC0'},
                {value: 'nc1', text: 'NC1'},
                {value: 'nc2', text: 'NC2'},
                {value: 'nc3', text: 'NC3'},
                {value: 'nc4', text: 'NC4'},
              ]"
                @change="search"
            ></dropdown>
            <dropdown
                v-if="filterFormModel.type === 5"
                :model="filterFormModel"
                attribute="fault"
                label="Lọc theo lỗi"
                :right-menu="true"
                type="bordered"
                icon="icon12-sort-descending-primary"
                :options="[
                {value: null, text: 'Tất cả'},
                {value: 'khongnghemay', text: 'Bệnh nhân không nghe máy'},
                {value: 'saiso', text: 'Số điện thoại không đúng'},
                {value: 'saithongtin', text: 'Sai thông tin bệnh nhân'}
              ]"
                @change="search"
            ></dropdown>
            <dropdown :model="filterFormModel" attribute="sort" :label="$t('sortBy')" :right-menu="true"
                      type="bordered" icon="icon12-sort-descending-primary" :options="[
                                {value: null, text: 'Mới đến cũ'},
                                {value: 'createTimeASC', text: 'Cũ đến mới'},
                                {value: 'lastCallTimeDESC', text: 'Thời gian chăm sóc mới --> cũ'},
                                {value: 'lastCallTimeASC', text: 'Thời gian chăm sóc cũ --> mới'},
                                {value: 'nextCallTimeASC', text: 'Lịch hẹn chăm sóc gần --> xa'},
                                {value: 'nameASC', text: 'Tên từ A -> Z'},
                                {value: 'nameDSC', text: 'Tên từ Z -> A'},
                                ]" @change="search"></dropdown>
            <time-range-picker :model="filterFormModel" label="Tạo lúc" @change="search"></time-range-picker>
            <time-range-picker :model="filterFormModel" attribute="updated_" label="Cập nhật lúc" @change="search"></time-range-picker>
            <dropdown :model="filterFormModel" attribute="pageSize" label="Phân trang" type="bordered" @change="search" :options="[
                {value: 10, text: '10'},
                {value: 20, text: '20'},
                {value: 30, text: '30'},
                {value: 40, text: '40'},
                {value: 50, text: '50'},
                {value: 100, text: '100'},
                {value: 200, text: '200'},
                {value: 500, text: '500'},
            ]"></dropdown>
            <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 c-action__left">
            <span class="c-action__count">
              {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, itemCount, 'bệnh nhân']) }}
            </span>
            <b-dropdown v-if="listSelectedBenhNhan.length > 0" variant="outline-primary" size="sm" text="Chọn hành động">
              <b-dropdown-item @click="benhNhanChangeUserInCharge.show({listBenhNhan: listSelectedBenhNhan})">
                Cập nhật phụ trách
              </b-dropdown-item>
              <b-dropdown-item @click="benhNhanUnfollow.show({listBenhNhan: listSelectedBenhNhan})">
                Ngừng theo dõi
              </b-dropdown-item>
              <b-dropdown-item @click="removeFault(listSelectedBenhNhan)">
                Gỡ lỗi
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="col-lg-9 c-action__right">
            <export
              :filter="filterFormModel"
              :total-count="itemCount"
              v-if="$store.state.user.permissions.includes('benhNhanExport')"
            ></export>
            <import-benh-nhan
              :reasonOptions="OPTIONS_TEST_REASON"
              v-if="$store.state.user.permissions.includes('benhNhanCreate')"
            />
            <b-button
              class="btn btn-success btn-sm"
              @click="benhNhanEditor.create()"
              v-if="$store.state.user.permissions.includes('benhNhanCreate') ||
              (['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy', 'support'].includes($store.state.user.role)
                && $store.state.user.group
                && ['610e362ce7aef55208d80670', '610e25b9d8ba7b532cc750a8'].includes($store.state.user.group))"
              data-toggle="modal"
              data-target="#partner-addnew"
            >
              <i class="icon12-add-white icon-left"></i>{{ $t('create') }}
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="text-center text-primary">
        <b-spinner></b-spinner>
      </div>
      <div v-if="!listLoading && !itemCount" class="text-center text-danger">
        {{ $t('emptyList') }}
      </div>
      <div v-if="!listLoading && itemCount" class="c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th class="th-check" v-if="['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role)">
              <b-form-checkbox
                v-model="selectedAll"
                :indeterminate="selectedAll === null"
              >
              </b-form-checkbox>
            </th>
            <th class="th-check">#</th>
            <th style="min-width: 300px">Bệnh nhân</th>
            <th style="min-width: 100px" class="text-center">Nhóm NC</th>
            <th style="min-width: 250px" class="text-center">Trạng thái chăm sóc</th>
            <th style="min-width: 300px">Thông tin chăm sóc</th>
            <th style="min-width: 250px">Phụ trách chăm sóc</th>
            <th class="th-check" v-if="$store.state.user.permissions.includes('benhNhanCreate')"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="item._id">
            <td class="th-check" v-if="['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role)">
              <b-form-checkbox :value="item._id" v-model="listSelectedBenhNhanId"></b-form-checkbox>
            </td>
            <td class="th-check">{{index + 1}}</td>
            <td>
              <p><b>Tên:</b> {{ item.name ? item.name : $t('unknown') }}</p>
              <p><b>Năm sinh:</b> {{ item.dob ? item.dob : $t('unknown') }}</p>
              <p v-if="item.age"><b>Tuổi: </b>{{item.age}}</p>
              <p><b>Giới tính:</b> {{ item.gender === 'male' ? 'Nam' : item.gender === 'female' ? 'Nữ' : 'Không rõ' }}</p>
              <p v-if="item.testCode"><b>Mã xét nghiệm:</b> {{item.testCode}}</p>
              <p v-if="item.note"><b>Ghi chú:</b> {{item.note}}</p>
              <p v-if="item.informantPhone"><b>SĐT người báo tin: </b> {{item.informantPhone}}</p>
              <template v-if="$store.state.user.permissions.includes('contactInfoShow') && item.tier && ['nc3', 'nc4'].includes(item.tier)">
                <hr>
                <p><b>SĐT: </b> {{item.phone}}</p>
                <p><b>Địa chỉ: </b> {{item.address ? item.address : 'Không rõ'}}</p>
                <div v-html="getProvinceDistrictWard(item.provinceCode, item.districtCode, item.wardCode)"></div>
                <hr>
              </template>
              <p class='mt-2' v-if="item.fault">
                <span class="badge badge-danger glow" v-b-tooltip.hover.bottom='item.faultDetail'>
                  {{ reportFaultOptions.find(fault => fault.value === item.fault).text }}
                </span>
              </p>
              <p v-if="!item.stopFollowTime && item.firstCallTime && item.tier && ['nc0', 'nc1'].includes(item.tier)
                      && item.firstCallTime < Date.now() - 10 * 24 * 60 * 60 * 1000
                      && (!item.nextTier || item.nextTier === item.tier)">
                <span class="badge badge-success">BN đã được theo dõi trên 10 ngày và đủ điều kiện để ngừng theo dõi</span>
              </p>
              <p v-if="item.stopFollowTime"><span class="badge badge-secondary">Đã ngừng theo dõi</span></p>
              <p v-if="item.stopFollowTime && item.stopFollowBy">
                <b>Ngừng theo dõi bởi: </b><span>{{item.stopFollowBy.name}} ({{item.stopFollowBy.email}})</span>
              </p>
              <p class="mt-1">
                <button
                  v-if="!item.stopFollowTime && !item.stopFollowRequestTime && !item.emergencyTime &&
                      (['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role) ||
                        ($store.state.user.role === 'bac-sy' && ['nc0', 'nc1', 'nc2'].includes(item.tier)))"
                  class="btn btn-sm btn-outline-gray mr-1 mb-1"
                  @click="benhNhanUnfollow.show({listBenhNhan: [item]})"
                >
                  <i class="fa fa-ban"></i>
                  Ngừng theo dõi
                </button>
                <button
                  v-if="!item.stopFollowTime && !item.stopFollowRequestTime && $store.state.user.role === 'nvyt'"
                  class="btn btn-sm btn-outline-gray mr-1 mb-1"
                  @click="benhNhanCreateUnfollowRequest.show(item)"
                >
                  <i class="fa fa-ban"></i>
                  Đề xuất ngừng theo dõi
                </button>
                <button-refollow
                  :benhNhan="item"
                  v-if="
                    item.stopFollowTime &&
                      (['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role) ||
                        ($store.state.user.role === 'bac-sy' && item.doctorUser === $store.state.user._id))
                  "
                >
                </button-refollow>
                <button
                  class="btn btn-sm btn-outline-gray mr-1 mb-1"
                  @click="removeFault([item])"
                  v-if="item.fault"
                  :disabled="saveLoading"
                >
                  <i v-if="!saveLoading" class="icon12-markdone-primary"></i>
                  <b-spinner v-else small></b-spinner>
                  Gỡ lỗi
                </button>
              </p>
              <div v-if="item.stopFollowRequestTime">
                <hr />
                <h5>
                  Đề xuất ngừng theo dõi
                </h5>
                <p>
                  <b>Thời gian: </b>
                  <span>{{ item.stopFollowRequestTime | moment('DD/MM/YY HH:mm') }}</span>
                </p>
                <p>
                  <b>Lý do: </b>
                  <span>{{ STOP_FOLLOW_REASON_TO_TEXT[item.stopFollowReason] || item.stopFollowReason }}</span>
                </p>
                <p>
                  <b>Mô tả: </b>
                  <span>{{ item.stopFollowReasonDetail || 'Không có' }}</span>
                </p>
                <div
                  v-if="
                    ['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes($store.state.user.role) ||
                      ($store.state.user.role === 'bac-sy' && ['nc0', 'nc1', 'nc2'].includes(item.tier))
                  "
                >
                  <p>
                    <span class="badge badge-warning glow mb-1">
                      <b-spinner type="grow" small></b-spinner>
                      Cần duyệt đề xuất ngừng theo dõi
                    </span>
                  </p>
                  <p>
                    <button-approve-unfollow-request :benh-nhan="item">Duyệt</button-approve-unfollow-request>
                    <button-reject-unfollow-request :benh-nhan="item">Từ chối</button-reject-unfollow-request>
                  </p>
                </div>
              </div>
            </td>
            <td class="text-center">
              <p class="mb-1">
                <span v-if="!item.tier" class="badge badge-secondary">Chưa cập nhật</span>
                <span v-else-if="item.tier === 'nc0'" class="badge badge-success">NC0</span>
                <span v-else-if="item.tier === 'nc1'" class="badge badge-info">NC1</span>
                <span v-else-if="item.tier === 'nc2'" class="badge badge-primary">NC2</span>
                <span v-else-if="item.tier === 'nc3'" class="badge badge-warning">NC3</span>
                <span v-else class="badge badge-danger">NC4</span>
              </p>

              <p v-if="item.nextTier && item.tier && item.nextTier !== item.tier">
                  <span class="badge badge-warning glow mb-1">
                    <b-spinner type="grow" small></b-spinner> Cần duyệt chuyển {{ item.nextTier }}
                  </span>
              </p>
              <p v-if="item.nextTier && item.tier && item.nextTier !== item.tier">
                <button v-if="changeNCPermission(item)" class="btn btn-sm btn-outline-gray mr-1 mb-1"
                        @click="changeNC(item, 'approve')">
                  <i class="fa fa-check"></i>
                  Duyệt
                </button>
                <button v-if="changeNCPermission(item)" class="btn btn-sm btn-outline-gray mr-1 mb-1"
                        @click="changeNC(item, 'reject')">
                  <i class="fa fa-ban"></i>
                  Từ chối
                </button>
              </p>
            </td>
            <td class="text-center">
              <emergency-state-badges :benhNhan="item"></emergency-state-badges>
              <emergency-action-buttons
                :benhNhan="item"
                @emergency-request-create="emergencyRequestCreate().show([item])"
                @emergency-request-approve="emergencyRequestApprove().show([item])"
                @emergency-request-cancel="emergencyRequestCancel().show([item])"
                @unfollow="emergencyUnfollow().show([item])"
                @emergency-community-care-request-create="emergencyCommunityCareRequestCreate().show([item])"
                @emergency-community-care-request-approve="emergencyCommunityCareRequestApprove().show([item])"
                @emergency-community-care-request-cancel="emergencyCommunityCareRequestCancel().show([item])"
              ></emergency-action-buttons>
            </td>
            <td>
              <p>
                <b>Tạo lúc: </b>
                <span> {{ item.createTime | moment('DD/MM/YY HH:mm') }}</span>
              </p>
              <p>
                <b>Lần chăm sóc cuối: </b>
                <span v-if="item.lastCallTime"> {{ item.lastCallTime | moment('DD/MM/YY HH:mm') }}</span>
                <span v-else>Chưa cập nhật</span>
              </p>
              <p>
                <b>Lần chăm sóc tiếp theo: </b>
                <span v-if="item.nextCallTime"> {{ item.nextCallTime | moment('DD/MM/YY HH:mm') }}</span>
                <span v-else>Chưa cập nhật</span>
              </p>
              <p class="mt-1">
                <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="benhNhanHistoryHandler(item)">
                  <i class="fa fa-history"></i>
                  Lịch sử chăm sóc
                </button>
                <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="addBenhNhanCallHandler(item)"
                        v-if="(item.tier && $store.state.user.role === 'nvyt') || ['cap-cuu', 'bac-sy', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'owner'].includes($store.state.user.role)">
                  <i class="fa fa-phone"></i>
                  Gọi chăm sóc
                </button>
              </p>
            </td>
            <td>
              <p v-if="item.seniorDoctorUser">
                <b v-b-tooltip="'Bác sỹ trưởng nhóm/Bác sỹ phó nhóm'">BSTN/BSPN: </b>
                <a href="javascript:;" v-b-tooltip="'Nhấn để xem chi tiết'" @click="showUserInfo(item.seniorDoctorUser)">
                  {{item.seniorDoctorUser.name}}
                </a>
              </p>
              <p v-if="item.emergencyDoctorUser && item.requestEmergencyReceiveTime">
                <b>Bác sĩ cấp cứu: </b>
                <a href="javascript:;" v-b-tooltip="'Nhấn để xem chi tiết'" @click="showUserInfo(item.emergencyDoctorUser)">
                  {{item.emergencyDoctorUser.name}}
                </a>
              </p>
              <p>
                <b>Bác sĩ: </b>
                <a href="javascript:;" v-b-tooltip="'Nhấn để xem chi tiết'"
                  v-if="item.doctorUser" @click="showUserInfo(item.doctorUser)">
                  {{item.doctorUser.name}}
                </a>
                <span v-else>Chưa phân công</span>
              </p>
              <p>
                <b>TNV: </b>
                <a href="javascript:;" v-b-tooltip="'Nhấn để xem chi tiết'"
                  v-if="item.followUser" @click="showUserInfo(item.followUser)">
                  {{item.followUser.name}}
                </a>
                <span v-else>Chưa phân công</span>
              </p>
              <p>
                <b>Nhóm: </b>
                <span>{{item.group ? item.group.name : 'Chưa phân nhóm'}}</span>
              </p>
              <button class="btn btn-sm btn-outline-gray mr-1 mb-1 mt-1"
                  @click="benhNhanChangeUserInCharge.show({listBenhNhan: [item]})"
                  v-if="['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy', 'owner'].includes($store.state.user.role)">
                <i class="fa fa-user"></i>
                Đổi phụ trách
              </button>
              <benh-nhan-change-group :benh-nhan="item"></benh-nhan-change-group>
              <hr v-if="item.fieldDoctor || item.fieldDoctorPhone">
              <p v-if="item.fieldDoctor"><b>Bác sĩ địa phương:</b></p>
              <p v-if="item.fieldDoctor">
                <span>{{ item.fieldDoctor }}</span>
                <span v-if="item.fieldDoctorPhone"> - </span>
                <span v-if="item.fieldDoctorPhone">
                  <a @click="makeCall(item.fieldDoctorPhone)" href="javascript:;" v-b-tooltip="'Nhấn để gọi'">
                    {{ item.fieldDoctorPhone }}
                  </a>
                </span>
              </p>
            </td>
            <td class="th-check" v-if="$store.state.user.permissions.includes('benhNhanCreate')">
              <button
                  class="btn btn-sm btn-outline-gray mr-1 mb-1"
                  @click="benhNhanEditor.update(item._id)"
                  :disabled="benhNhanEditor.updateLoading"
                  v-if="$store.state.user.role === 'owner'"
              >
                <b-spinner v-if="benhNhanEditor.updateLoading" small></b-spinner>
                <i v-else class="fa fa-edit"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination
            size="sm"
            class="pagination pagination-sm justify-content-center"
            v-model="filterFormModel.page"
            :total-rows="itemCount"
            :per-page="filterFormModel.pageSize"
            @input="load"
        >
        </b-pagination>
      </div>
    </div>

    <benh-nhan-history
        :benhNhan="selectedBenhNhan"
        v-if="enableBenhNhanHistoryModal"
        @hidden="enableBenhNhanHistoryModal = false"
    ></benh-nhan-history>

    <add-benh-nhan-call
        :benhNhan="selectedBenhNhan"
        v-if="enableAddBenhNhanCallModal"
        @hidden="
          enableAddBenhNhanCallModal = false;
          campaignFiftyCallPopupBanner().checkAndShow();
        "
    ></add-benh-nhan-call>

    <benh-nhan-editor :ref="MODAL_REF.BENH_NHAN_EDITOR"></benh-nhan-editor>
    <benh-nhan-change-user-in-charge :ref="MODAL_REF.BENH_NHAN_CHANGE_USER_IN_CHARGE"></benh-nhan-change-user-in-charge>
    <benh-nhan-unfollow :ref="MODAL_REF.BENH_NHAN_UNFOLLOW"></benh-nhan-unfollow>
    <benh-nhan-create-unfollow-request :ref="MODAL_REF.BENH_NHAN_CREATE_UNFOLLOW_REQUEST"></benh-nhan-create-unfollow-request>
    <change-n-c :ref="MODAL_REF.CHANGE_NC"></change-n-c>
    <campaign-fifty-call-popup-banner :ref="MODAL_REF.CAMPAIGN_FIFTY_CALL_POPUP_BANNER" />
    <emergency-request-create :ref="MODAL_REF.EMERGENCY_REQUEST_CREATE"></emergency-request-create>
    <emergency-request-approve :ref="MODAL_REF.EMERGENCY_REQUEST_APPROVE"></emergency-request-approve>
    <emergency-request-cancel :ref="MODAL_REF.EMERGENCY_REQUEST_CANCEL"></emergency-request-cancel>
    <emergency-unfollow :ref="MODAL_REF.EMERGENCY_UNFOLLOW"></emergency-unfollow>
    <emergency-community-care-request-create :ref="MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_CREATE"></emergency-community-care-request-create>
    <emergency-community-care-request-approve :ref="MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_APPROVE"></emergency-community-care-request-approve>
    <emergency-community-care-request-cancel :ref="MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_CANCEL"></emergency-community-care-request-cancel>

    <b-modal v-model="userModel" title="Thông tin tài khoản" ok-only>
      <div v-if="user">
        <p><b>Họ tên: </b><span>{{user.name}}</span></p>
        <p><b>Email: </b><span>{{user.email}}</span></p>
        <p><b>Số nhánh: </b>
          <a href="javascript:;" v-b-tooltip="'Nhấn để gọi nội bộ'" @click="makeCall(user.ext)">
            <i class="icon12-phone-volume-primary"></i> {{user.ext}}
          </a>
        </p>
        <p>
          <b>SĐT: </b>
          <a href="javascript:;" @click="makeCall(user.phone)" v-if="user.phone">
            <i class="icon12-phone-volume-primary"></i> {{ user.phone }}
          </a>
          <span v-else>Không rõ</span>
        </p>
        <p>
          <b>Online lần cuối: </b>
          <span v-if="user.lastOnlineTime">{{user.lastOnlineTime | moment('DD/MM/YY HH:mm:ss')}}</span>
          <span v-else>Chưa online lần nào</span>
        </p>
      </div>
    </b-modal>
  </main>
</template>

<script>

// Mixins
import list from '@/mixins/List';

// Utils
import _ from 'lodash';

// Constants
import OPTIONS_TEST_REASON from './constants/options-test-reason.json'
import OPTIONS_STOP_FOLLOW_REASON from './constants/options-stop-follow-reason.json';
import {EMERGENCY_STATE} from './modules/emergency/utils/emergencyUtils';

// Components
import AddBenhNhanCall from './AddBenhNhanCall.vue';
import BenhNhanChangeUserInCharge from './BenhNhanChangeUserInCharge.vue';
import BenhNhanChangeGroup from './BenhNhanChangeGroup.vue';
import BenhNhanCreateUnfollowRequest from './BenhNhanCreateUnfollowRequest.vue';
import BenhNhanEditor from './BenhNhanEditor.vue';
import BenhNhanHistory from './BenhNhanHistory.vue';
import BenhNhanUnfollow from './BenhNhanUnfollow.vue';
import ButtonApproveUnfollowRequest from './ButtonApproveUnfollowRequest.vue';
import ButtonRefollow from './ButtonRefollow.vue';
import ButtonRejectUnfollowRequest from './ButtonRejectUnfollowRequest.vue';
import ChangeNC from "./ChangeNC.vue";
import Dropdown from '@/components/Dropdown.vue';
import Export from './Export.vue';
import ImportBenhNhan from './ImportBenhNhan.vue';
import UserGroupSelect from '@/components/UserGroupSelect.vue';
import UserSelect from '@/components/UserSelect.vue';
import provinceData from '@/views/1022/vn-adm.json';
import TimeRangePicker from "@/components/TimeRangePicker";
import CampaignFiftyCallPopupBanner from './modules/campaign-fifty-call-popup-banner';
import EmergencyRequestCreate from './modules/emergency/modals/EmergencyRequestCreate.vue';
import EmergencyRequestApprove from './modules/emergency/modals/EmergencyRequestApprove.vue';
import EmergencyRequestCancel from './modules/emergency/modals/EmergencyRequestCancel.vue';
import EmergencyUnfollow from './modules/emergency/modals/EmergencyUnfollow.vue';
import EmergencyCommunityCareRequestCreate from './modules/emergency/modals/EmergencyCommunityCareRequestCreate.vue';
import EmergencyCommunityCareRequestApprove from './modules/emergency/modals/EmergencyCommunityCareRequestApprove.vue';
import EmergencyCommunityCareRequestCancel from './modules/emergency/modals/EmergencyCommunityCareRequestCancel.vue';
import EmergencyStateBadges from './modules/emergency/components/EmergencyStateBadges';
import EmergencyActionButtons from './modules/emergency/components/EmergencyActionButtons.vue';

const STOP_FOLLOW_REASON_TO_TEXT = Object.fromEntries(
  OPTIONS_STOP_FOLLOW_REASON.map(({value, text}) => [value, text])
);

const MODAL_REF = {
  BENH_NHAN_EDITOR: 'benh-nhan-editor--ref',
  BENH_NHAN_CHANGE_USER_IN_CHARGE: 'benh-nhan-change-user-in-charge--ref',
  BENH_NHAN_UNFOLLOW: 'benh-nhan-unfollow--ref',
  BENH_NHAN_CREATE_UNFOLLOW_REQUEST: 'benh-nhan-create-unfollow-request--ref',
  CHANGE_NC: 'changeNC',
  CAMPAIGN_FIFTY_CALL_POPUP_BANNER: 'campaign-fifty-call-popup-banner--ref',
  EMERGENCY_REQUEST_CREATE: 'emergency-request-create--ref',
  EMERGENCY_REQUEST_APPROVE: 'emergency-request-approve--ref',
  EMERGENCY_REQUEST_CANCEL: 'emergency-request-cancel--ref',
  EMERGENCY_UNFOLLOW: 'emergency-unfollow--ref',
  EMERGENCY_COMMUNITY_CARE_REQUEST_CREATE: 'emergency-community-care-request-create--ref',
  EMERGENCY_COMMUNITY_CARE_REQUEST_APPROVE: 'emergency-community-care-request-approve--ref',
  EMERGENCY_COMMUNITY_CARE_REQUEST_CANCEL: 'emergency-community-care-request-cancel--ref',
}

export default {
  components: {
    TimeRangePicker,
    AddBenhNhanCall,
    BenhNhanChangeUserInCharge,
    BenhNhanChangeGroup,
    BenhNhanCreateUnfollowRequest,
    BenhNhanEditor,
    BenhNhanHistory,
    BenhNhanUnfollow,
    ButtonApproveUnfollowRequest,
    ButtonRejectUnfollowRequest,
    ButtonRefollow,
    ChangeNC,
    Dropdown,
    Export,
    ImportBenhNhan,
    UserGroupSelect,
    UserSelect,
    CampaignFiftyCallPopupBanner,
    EmergencyRequestCreate,
    EmergencyRequestApprove,
    EmergencyRequestCancel,
    EmergencyUnfollow,
    EmergencyCommunityCareRequestCreate,
    EmergencyCommunityCareRequestApprove,
    EmergencyCommunityCareRequestCancel,
    EmergencyStateBadges,
    EmergencyActionButtons,
  },
  mixins: [list],
  created() {
    // Let's add constants here
    // Source: https://coderethinked.com/3-different-ways-to-access-constants-in-a-vue-template/
    this.OPTIONS_TEST_REASON = OPTIONS_TEST_REASON;
    this.STOP_FOLLOW_REASON_TO_TEXT = STOP_FOLLOW_REASON_TO_TEXT;
    this.MODAL_REF = MODAL_REF;
    this.EMERGENCY_STATE = EMERGENCY_STATE;
  },
  data: function () {
    return {
      provinceData,
      service: '/benh-nhan',
      autoLoad: false,
      reloadBus: 'reloadBenhNhanList',
      showFormChangeNc: false,
      isDisableModel: false,
      defaultFilterFormModel: {
        group: ['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy'].includes(this.$store.state.user.role)  ? this.$store.state.user.group : null,
        doctorUser: this.$store.state.user.role === 'bac-sy' ? this.$store.state.user._id : null,
        phone: null
      },
      reportFaultOptions: [
        {value: 'khongnghemay', text: 'Bệnh nhân không nghe máy'},
        {value: 'saiso', text: 'Số điện thoại không đúng'},
        {value: 'saithongtin', text: 'Sai thông tin'},
      ],
      selectedBenhNhan: null,
      enableBenhNhanHistoryModal: false,
      enableAddBenhNhanCallModal: false,
      listSelectedBenhNhanId: [],
      saveLoading: false,
      userModel: false,
      user: {}
    };
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
    benhNhanHistoryHandler(benhNhan) {
      this.selectedBenhNhan = benhNhan;
      this.enableBenhNhanHistoryModal = true;
    },
    addBenhNhanCallHandler(benhNhan) {
      this.selectedBenhNhan = benhNhan;
      this.enableAddBenhNhanCallModal = true;
    },
    removeFault(benhNhans) {
      const benhNhanIds = benhNhans.map(item => item._id);
      this.$swal({
        icon: 'info',
        title: `Xác nhận muốn gỡ lỗi của ${benhNhanIds.length} bệnh nhân?`,
        showCancelButton: true
      }).then(confirm => {
        if (confirm.value) {
          this.saveLoading = true;
          this.$service.post(
            '/benh-nhan/remove-fault',
            { ids: benhNhanIds }
          ).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('success'),
                text: 'Gỡ lỗi thành công',
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: 'Gỡ lỗi thất bại thất bại',
                icon: 'error',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.saveLoading = false;
            this.load();
          })
        }
      })
    },
    changeNCPermission(item) {
      if (['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes(this.$store.state.user.role)) {
        return true
      }
      if (this.$store.state.user.role === 'bac-sy' && !['nc3', 'nc4'].includes(item.tier) && !['nc3', 'nc4'].includes(item.nextTier)) {
        return true
      }
      return false
    },
    changeNC(item, action) {
      this.$refs[MODAL_REF.CHANGE_NC].open(item, action)
    },
    showUserInfo(user) {
      this.user = user;
      this.userModel = true;
    },
    getProvinceDistrictWard(provinceCode, districtCode, wardCode) {
      let result = {
        province: 'Không rõ',
        district: 'Không rõ',
        ward: 'Không rõ'
      }
      if (provinceCode) {
        let province = this.provinceData.find(p => p.value.toString() === provinceCode.toString());
        if (province) {
          result.province = province.text;
          let district = province.districts.find(d => d.value.toString() === districtCode.toString());
          if (district) {
            result.district = district.text;
            let ward = district.wards.find(w => w.value.toString() === wardCode.toString());
            if (ward) {
              result.ward = ward.text;
            }
          }
        }
      }
      return `
                    <p><b>Tỉnh/ TP: </b><span>${result.province}</span></p>
                    <p><b>Quận/ Huyện: </b><span>${result.district}</span></p>
                    <p><b>Xã/ Phường: </b><span>${result.ward}</span></p>
              `
    },
    campaignFiftyCallPopupBanner() {
      return this.$refs[MODAL_REF.CAMPAIGN_FIFTY_CALL_POPUP_BANNER];
    },
    emergencyRequestCreate() {
      return this.$refs[MODAL_REF.EMERGENCY_REQUEST_CREATE];
    },
    emergencyRequestApprove() {
      return this.$refs[MODAL_REF.EMERGENCY_REQUEST_APPROVE];
    },
    emergencyRequestCancel() {
      return this.$refs[MODAL_REF.EMERGENCY_REQUEST_CANCEL];
    },
    emergencyUnfollow() {
      return this.$refs[MODAL_REF.EMERGENCY_UNFOLLOW];
    },
    emergencyCommunityCareRequestCreate() {
      return this.$refs[MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_CREATE];
    },
    emergencyCommunityCareRequestApprove() {
      return this.$refs[MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_APPROVE];
    },
    emergencyCommunityCareRequestCancel() {
      return this.$refs[MODAL_REF.EMERGENCY_COMMUNITY_CARE_REQUEST_CANCEL];
    },
  },
  computed: {
    customerCreatePermission() {
      return this.$store.state.user.permissions.includes('customerCreate');
    },
    customerExportPermission() {
      return this.$store.state.user.permissions.includes('customerExport');
    },
    groupIds() {
      if (
          this.$store.state.user.permissions.includes('customerListGroup') &&
          !this.$store.state.user.permissions.includes('customerListAll')
      ) {
        return this.$store.state.user.roleGroups;
      }
      return null;
    },
    listSelectedBenhNhan() {
      /*
        NOTE: listSelectedBenhNhan.length vs listSelectedBenhNhanId.length might be different.

        Consider this sequence:
          1. User selects some items
          2. User performs an action which trigger reloadBenhNhanList
          3. this.items is changed. Some selected items are not in this.items anymore.
          4. listSelectedBenhNhan.length < listSelectedBenhNhanId.length
        Therefore, please use listSelectedBenhNhan.length.

        Possible solutions:
        1. Avoid triggering reloadBenhNhanList
        2. Watch this.items: if this.items changes, update listSelectedBenhNhanId accordingly
      */
      return this.items.filter(item => this.listSelectedBenhNhanId.includes(item._id));
    },
    benhNhanEditor() {
      return this.$refs[MODAL_REF.BENH_NHAN_EDITOR];
    },
    benhNhanChangeUserInCharge() {
      return this.$refs[MODAL_REF.BENH_NHAN_CHANGE_USER_IN_CHARGE];
    },
    benhNhanUnfollow() {
      return this.$refs[MODAL_REF.BENH_NHAN_UNFOLLOW];
    },
    benhNhanCreateUnfollowRequest() {
      return this.$refs[MODAL_REF.BENH_NHAN_CREATE_UNFOLLOW_REQUEST];
    },
    selectedAll: {
      get() {
        switch (this.listSelectedBenhNhan.length) {
          case 0:
            return false;
          case this.items.length:
            return true;
          default:
            return null; // Indeterminate
        }
      },
      set(value) {
        switch (value) {
          case true:
            this.listSelectedBenhNhanId = this.items.map(item => item._id);
            break;
          case false:
            this.listSelectedBenhNhanId = [];
            break;
          case null:
            break; // Indeterminate
        }
      },
    },
  },
};
</script>
